import {ValueObject} from '@s-ui/domain'

export class LoanCalculationsTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Number} data.minEntry
   * @param {Number} data.maxEntry
   * @param {Array<Number>} data.availableTerms
   * @param {Number} data.fee
   * @param {Number} data.openingExpenses
   * @param {Boolean} data.isOpeningExpensesFinanced
   * @param {Number} data.tin
   * @param {Number} data.tae
   * @param {Number} data.totalAmountDue
   * @param {Number} data.totalLoanAmount
   * @param {Number} data.openingPercentage
   * @param {Number} data.totalInterest
   * @param {Number} data.totalLoanCost
   */
}
